/* EBB — Digital hospitality
   Self-contained, additive script. Degrades silently if JS is off or DOM
   targets are missing. Does not modify or replace any existing feature —
   only wraps ebbRenderShopifyCart (same pattern as the "Pairs well with"
   module in layout/theme.liquid) and appends to the homepage hero area.
   Modules: A quiet hour welcome · B cart confirmation line · C gift note
   (native cart `note` attribute via /cart/update.js).
   ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  /* ═══ A. The quiet hour — first-ever-visit homepage welcome strip ═══ */
  var SEEN_KEY = 'ebb_seen';
  var WELCOME_LINE = 'Welcome. Most of this was built before sunrise — take your time.';

  function initQuietHour() {
    try {
      if (localStorage.getItem(SEEN_KEY)) return; // already seen — never show again
    } catch (e) {
      return; // localStorage unavailable — degrade silently
    }

    var heroWrap = document.querySelector('#page-home .hero-wrap');
    if (!heroWrap || !heroWrap.parentNode) return; // not on homepage — no-op

    try {
      var strip = document.createElement('div');
      strip.className = 'eh-welcome';
      strip.id = 'ehWelcome';
      var p = document.createElement('p');
      p.className = 'eh-welcome-text';
      p.textContent = WELCOME_LINE;
      strip.appendChild(p);
      heroWrap.parentNode.insertBefore(strip, heroWrap);

      // Reveal on next frame for a soft fade/slide-in, then persist the flag.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          strip.classList.add('eh-in');
        });
      });

      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) { /* ignore */ }
    } catch (e) {
      /* never block the page */
    }
  }

  /* ═══ B. Quiet confirmation — cart drawer footer line ═══ */
  var CART_LINES = [
    'Free shipping across Canada, always — no minimum required.',
    'Free returns within 30 days, no questions asked.',
    'Packed with care, by hand, before it ever reaches you.',
    'Take your time — this cart will keep until you\'re ready.',
    'Shipped from Canada, to Canada, free every time.',
    'Thirty days to decide. No rush on our end.'
  ];
  var SESSION_KEY = 'ebb_cart_note_idx';

  function pickLineIndex() {
    try {
      var stored = sessionStorage.getItem(SESSION_KEY);
      if (stored !== null && !isNaN(parseInt(stored, 10))) {
        return parseInt(stored, 10) % CART_LINES.length;
      }
      var idx = Math.floor(Math.random() * CART_LINES.length);
      sessionStorage.setItem(SESSION_KEY, String(idx));
      return idx;
    } catch (e) {
      return 0; // sessionStorage unavailable — stable fallback, still degrades silently
    }
  }

  function renderCartNote() {
    try {
      var ft = document.getElementById('cartFt');
      if (!ft) return;
      if (document.getElementById('ehCartNote')) return; // idempotent — already present

      var trust = ft.querySelector('.cart-trust');
      var note = document.createElement('div');
      note.className = 'eh-cart-note';
      note.id = 'ehCartNote';
      note.textContent = CART_LINES[pickLineIndex()];

      if (trust && trust.parentNode) {
        trust.parentNode.insertBefore(note, trust.nextSibling);
      } else {
        ft.appendChild(note);
      }
    } catch (e) {
      /* never block the cart */
    }
  }

  /* ═══ C. Gift note — cart drawer footer, native cart `note` attribute ═══ */

  function giftStatusEl() { return document.getElementById('ehGiftStatus'); }
  function giftTaEl() { return document.getElementById('ehGiftTa'); }
  function giftToggleEl() { return document.getElementById('ehGiftToggle'); }

  function setGiftToggleLabel() {
    var t = giftToggleEl();
    var ta = giftTaEl();
    if (!t) return;
    var has = ta && ta.value.trim().length > 0;
    t.textContent = has ? 'Edit gift note' : 'Add a gift note';
  }

  function saveGiftNote() {
    var ta = giftTaEl();
    var btn = document.getElementById('ehGiftSave');
    var st = giftStatusEl();
    if (!ta || !btn) return;
    var val = ta.value.trim();
    btn.disabled = true;
    if (st) st.textContent = 'Saving…';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: val })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('bad status');
        return r.json();
      })
      .then(function (d) {
        btn.disabled = false;
        try { if (window.EBB_CART) window.EBB_CART.note = d.note; } catch (e) {}
        if (st) st.textContent = val ? 'Gift note saved' : 'Gift note removed';
        setGiftToggleLabel();
      })
      .catch(function () {
        btn.disabled = false;
        if (st) st.textContent = 'Couldn’t save just now — please try again.';
      });
  }

  function buildGiftUI() {
    var wrap = document.createElement('div');
    wrap.className = 'eh-gift';
    wrap.id = 'ehGiftWrap';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'eh-gift-toggle';
    toggle.id = 'ehGiftToggle';
    toggle.textContent = 'Add a gift note';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function () {
      var open = wrap.classList.toggle('eh-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var ta = giftTaEl();
        if (ta) ta.focus();
      }
    });

    var body = document.createElement('div');
    body.className = 'eh-gift-body';

    var ta = document.createElement('textarea');
    ta.className = 'eh-gift-ta';
    ta.id = 'ehGiftTa';
    ta.placeholder = 'A few words for the person opening this…';
    ta.maxLength = 500;
    ta.setAttribute('aria-label', 'Gift note');

    var row = document.createElement('div');
    row.className = 'eh-gift-row';

    var save = document.createElement('button');
    save.type = 'button';
    save.className = 'eh-gift-save';
    save.id = 'ehGiftSave';
    save.textContent = 'Save note';
    save.addEventListener('click', saveGiftNote);

    var status = document.createElement('span');
    status.className = 'eh-gift-status';
    status.id = 'ehGiftStatus';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    row.appendChild(save);
    row.appendChild(status);
    body.appendChild(ta);
    body.appendChild(row);
    wrap.appendChild(toggle);
    wrap.appendChild(body);
    return wrap;
  }

  function renderGiftNote(data) {
    try {
      var ft = document.getElementById('cartFt');
      if (!ft) return;

      if (!document.getElementById('ehGiftWrap')) {
        var ui = buildGiftUI();
        var anchor = document.getElementById('ehCartNote') || ft.querySelector('.cart-trust');
        if (anchor && anchor.parentNode === ft) {
          ft.insertBefore(ui, anchor.nextSibling);
        } else {
          ft.appendChild(ui);
        }
      }

      // Sync from cart data on each render — but never clobber active typing.
      if (data && typeof data.note !== 'undefined') {
        var ta = giftTaEl();
        if (ta && document.activeElement !== ta) {
          ta.value = data.note || '';
        }
        setGiftToggleLabel();
      }
    } catch (e) {
      /* never block the cart */
    }
  }

  function hookCartRender() {
    if (typeof window.ebbRenderShopifyCart !== 'function') return false;
    var original = window.ebbRenderShopifyCart;
    if (original.__ebbHospitalityWrapped) return true; // already wrapped
    window.ebbRenderShopifyCart = function (data) {
      original(data);
      try { renderCartNote(); } catch (e) { /* ignore */ }
      try { renderGiftNote(data); } catch (e) { /* ignore */ }
    };
    window.ebbRenderShopifyCart.__ebbHospitalityWrapped = true;
    return true;
  }

  function initQuietConfirmation() {
    if (hookCartRender()) return;
    // theme.js may still be loading (it's deferred) — poll briefly, then give up silently.
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (hookCartRender() || attempts > 40) clearInterval(timer);
    }, 250);
  }

  function init() {
    /* Quiet-hour welcome strip removed per client request. */
    initQuietConfirmation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
